function getXCoord(shot) {
  return 42.5 + shot.y;
}

function getYCoord(shot) {
  return 100 - shot.x;
}

const zones = {
  downLow: 'downLow',
  lowSlot: 'lowSlot',
  slot: 'slot',
  rightLow: 'rightLow',
  rightSlot: 'rightSlot',
  leftLow: 'leftLow',
  leftSlot: 'leftSlot',
  rightOne: 'rightOne',
  rightTwo: 'rightTwo',
  highSlot: 'highSlot',
  leftOne: 'leftOne',
  leftTwo: 'leftTwo',
  rightPoint: 'rightPoint',
  centerPoint: 'centerPoint',
  leftPoint: 'leftPoint',
  long: 'long'
};

function getShotZone(shot, transformPoints) {

  const x = transformPoints ? getXCoord(shot) : shot.x;
  const y = transformPoints ? getYCoord(shot) : shot.y;

  if (y < 11) {
    return zones.downLow;
  }
  else if (y >= 11 && y < 31) {
    if (x < 20.5) {
      return zones.leftLow;
    }
    else if (x >= 20.5 && x < 31.5) {
      // y =-20/11x + 751/11;
      if (-20 / 11 * x + 751 / 11 > y) {
        return zones.leftLow;
      }
      else {
        return zones.leftSlot;
      }
    }
    else if (x >= 31.5 && x < 53.5) {
      if (y < 21) {
        return zones.lowSlot;
      }
      else {
        return zones.slot;
      }
    }
    else if (x >= 53.5 && x < 64.5) {
      // y =20/11x - 949/11;
      if (20 / 11 * x - 949 / 11 > y) {
        return zones.rightLow;
      }
      else {
        return zones.rightSlot;
      }
    }
    else {
      return zones.rightLow;
    }
  }
  else if (y >= 31 && y < 46) {
    if (x < 20.5) {
      return zones.leftOne;
    }
    else if (x >= 20.5 && x < 31.5) {
      return zones.leftTwo;
    }
    else if (x >= 31.5 && x < 53.5) {
      return zones.highSlot;
    }
    else if (x >= 53.5 && x < 64.5) {
      return zones.rightTwo;
    }
    else {
      return zones.rightOne;
    }
  }
  else if (y >= 46 && y < 75) {
    if (x < 31.5) {
      return zones.leftPoint;
    }
    else if (x >= 31.5 && x < 53.5) {
      return zones.centerPoint;
    }
    else {
      return zones.rightPoint;
    }
  }
  else {
    return zones.long;
  }
}

function getPercentage(zone, shots, goals) {
  const s = shots[zone] || 0;
  const g = goals[zone] || 0;

  return s ? (Math.round(g / s * 1000) / 10) : 0;
}

function createShotZonePercents(shotsCollection) {
  const shots = {};
  const goals = {};

  if (shotsCollection && shotsCollection.length) {
    shotsCollection.forEach(d => {
      if ((d.type === 'Shot' || d.type === 'Goal') && !d.shootOut) {
        shots[d.zone] = (shots[d.zone] || 0) + 1;

        if (d.made) {
          goals[d.zone] = (goals[d.zone] || 0) + 1;
        }
      }
    });
  }

  return {
    shots,
    goals,
    percentages: {
      downLow: getPercentage('downLow', shots, goals),
      lowSlot: getPercentage('lowSlot', shots, goals),
      slot: getPercentage('slot', shots, goals),
      rightLow: getPercentage('rightLow', shots, goals),
      rightSlot: getPercentage('rightSlot', shots, goals),
      leftLow: getPercentage('leftLow', shots, goals),
      leftSlot: getPercentage('leftSlot', shots, goals),
      rightOne: getPercentage('rightOne', shots, goals),
      rightTwo: getPercentage('rightTwo', shots, goals),
      highSlot: getPercentage('highSlot', shots, goals),
      leftOne: getPercentage('leftOne', shots, goals),
      leftTwo: getPercentage('leftTwo', shots, goals),
      rightPoint: getPercentage('rightPoint', shots, goals),
      centerPoint: getPercentage('centerPoint', shots, goals),
      leftPoint: getPercentage('leftPoint', shots, goals),
      long: getPercentage('long', shots, goals)
    }
  }
}

exports.getXCoord = getXCoord;
exports.getYCoord = getYCoord;
exports.getShotZone = getShotZone;
exports.getShotZonePercents = createShotZonePercents;
exports.zones = zones;


// WEBPACK FOOTER //
// ./src/utils/shot-utils.js